import { Component, OnInit } from '@angular/core';
import {AppComponent} from "../../../app.component";
import * as $ from "jquery";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent extends AppComponent implements OnInit {

  isOpen: boolean;

  constructor() {
    super();
    this.isOpen = true;
  }

  ngOnInit(): void {
    this.isOpen = true;
  }

  toggleSidebar(){
    if(this.isOpen){
      $("#leftBar").hide();
      this.isOpen = false
    }else{
      $("#leftBar").show();
      this.isOpen = true;
    }
  }

}
